import React, { useState, useEffect, useMemo } from 'react'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import ImageGallery from 'react-image-gallery'
import "react-image-gallery/styles/css/image-gallery.css"
import PanelHeader from "./PanelHeader"

export default function Grace() {
    const [exists, setExists] = useState(null);
    const [loading, setLoading] = useState(true);
    const panelTitle = "GRACE Goundwater and Soil Moisture Conditions"
    const mapurl = 'https://nasagrace.unl.edu/data/'

    const datePart = useMemo(() => {
      const today = new Date();
      const dayOfWeek = today.getDay(); // Sunday is 0, Monday is 1, ..., Saturday is 6
      // Calculate the number of days to subtract to reach the last Monday
      // If today is Monday (1), subtract 7 days to get last Monday.
      // Otherwise, subtract (dayOfWeek - 1) to get to current week's Monday,
      // then subtract 7 more days to get to last Monday.
      const daysToSubtract = dayOfWeek === 1 ? 7 : (dayOfWeek + 6) % 7;
      today.setDate(today.getDate() - daysToSubtract);
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}${month}${day}`;
    }, [])

    const graceMaps = useMemo(() => {
      const maptitles = {
          'GWS': 'Groundwater',
          'RTZSM': 'Root Zone',
          'SFSM': 'Surface',
      }
      let maplist = [];
      Object.keys(maptitles).forEach((t) => {
        const mapname = mapurl + datePart + "/GRACE_" + t + "_" + datePart + ".png"
        maplist.push({
          original: mapname,
          thumbnail: mapname,
          thumbnailLabel: maptitles[t] || ""
        })
      })
      return maplist;
    }, [mapurl, datePart])

    useEffect(() => {
      const checkFile = async () => {
        try {
          const response = await fetch(graceMaps[0].original, { method: 'HEAD' });
          if (response.ok) {
            setExists(true);
          } else {
            setExists(false); 
          }
        } catch (error) {
          console.error("Error verifying file location:", error);
          setExists(false); // Network errors or CORS failures
        } finally {
          setLoading(false);
        }
      };
      checkFile();
    }, [graceMaps])

    return (
      <>
        <PanelHeader
          title={panelTitle}
        />
        {exists &&
          <div className="mapandlegend-container">
            <ImageGallery 
              items={graceMaps} 
              thumbnailPosition="bottom"
              showFullscreenButton={false}
              showPlayButton={false}
              showNav={false}
              slideDuration={200}
              slideInterval={9999}
              startIndex={1}
            />
            <div style={{textAlign:"center", margin:"1em 0"}}>
              Maps are available at the&nbsp;
              <Link href="https://nasagrace.unl.edu/" target="_blank" rel="noreferrer">
                  GRACE web site
              </Link>
              &nbsp;through a partnership with the National Drought Mitigation Center.
            </div>
          </div>
        }
        {!loading && !exists &&
          <Typography variant='body1' sx={{ fontStyle: 'italic' }}>
            GRACE maps for {datePart.slice(0, 4)}-{datePart.slice(4, 6)}-{datePart.slice(6, 8)} are not available at this time.
          </Typography>
        }
      </>
    )
}
